class BESSAppProjectSidebar extends BESSAppBase {

    constructor() {
        super();
        this.node = $('.sidebar');
        this.toggle = new BESSAppProjectSidebarToggle(this);

        $(window).scroll(this.#highlightActiveNavSection.bind(this));

        $('.app-section-nav').each(function () {

            let navLink = $(this);
            let navId = navLink.attr('data-nav-id');
            let nav = $('#' + navId);
            nav.addClass('app-section-nav-target');

        });
        this.#highlightActiveNavSection();
        this.subscribeToEvents(BESSAppScreenLayoutChangedEvent.name, this.#highlightActiveNavSection);

        let activeSection = this.node.find('.active-section');
        let activeSectionSubItems = activeSection.find('.sub-items');
        let toggle = activeSection.find('.app-toggle-section');
        toggle.bindClickEvent(this, function () {
            activeSection.toggleClass('app-collapse-section');
            if (activeSection.hasClass('app-collapse-section')) {
                activeSectionSubItems.slideUp();
                toggle.attr('title', 'Expand category');
            } else {
                activeSectionSubItems.slideDown();
                toggle.attr('title', 'Collapse category');
            }
        });

        let upgradeButton = this.node.find('.app-btn-upgrade');
        upgradeButton.bindClickEvent(this, this.#onUpgradeProject.bind(this));
        if (upgradeButton.hasClass('app-upgrade-in-progress')) {
            this.#onMonitorUpgradeProject();
        }

    }

    #highlightActiveNavSection() {
        $('.app-section-nav').removeClass('active');
        let sections = $(".app-section:visible, .app-section h1:visible, .app-section h2:visible, .app-section h3:visible, .app-section .app-section-inner:visible, .app-section .app-section-marker:visible");
        if (sections.length > 0) {
            _.each(sections, function (sectionNode) {
                let section = $(sectionNode);
                let isVisible = section.visible();

                if (isVisible) {
                    if (!section.hasClass('app-section')) {
                        section = section.parents('.app-section');
                    }

                    let sectionId = section.data('section-id');
                    let nav = $('.app-section-nav[data-nav-id="' + sectionId + '"]');
                    if (!nav.hasClass('active')) {
                        nav.addClass('active');
                    }
                }
            });
        }
        this.#syncVisibleSections();
    }

    #syncVisibleSections() {

        $(".app-section-nav").each(function (sectionNode) {
            let navLink = $(this);
            let navId = navLink.attr('data-nav-id');
            let nav = $('#' + navId);

            let hidden = nav.hasClass('hidden');
            let parent = nav.parent();
            while (!hidden && parent.length > 0) {
                hidden = parent.hasClass('hidden');
                parent = parent.parent();
            }
            navLink.showIf(!hidden);

        });
    }

    #onUpgradeProject() {
        this.showDoingWork('Upgrade Project', 'Setting up this project for upgrade...');
        BESSApp.instance.services.api.project.apiUpgrade(this.#onMonitorUpgradeProject.bind(this));
    }

    #onMonitorUpgradeProject() {
        this.showDoingWork('Upgrade Project', 'Upgrading project....');
        this.doDelayed(this.#onCheckUpgradeProjectProgress, 1000);
    }

    #onCheckUpgradeProjectProgress() {
        BESSApp.instance.services.api.project.apiUpgradeProgress(function (result) {
            if (result.upgraded_project_url) {
                window.location.href = result.upgraded_project_url;
            } else {
                this.doDelayed(this.#onCheckUpgradeProjectProgress, 2500);
            }
        }.bind(this));

    }
}